export const changeName = ({ commit }, name) => {
    commit('setName', name);
};

export const checkMobileView = ({ dispatch }) => {
    const sm = 576
    const md = 768

    let isMobile = false

    if(window.matchMedia(`(max-width: ${sm}px)`).matches) {
        isMobile = 'sm'
    }
    else if(window.matchMedia(`(max-width: ${md}px)`).matches) {
        isMobile = 'md'
    }

    dispatch('changeIsMobile', isMobile)
}

export const changeIsMobile = ({ commit }, isMobile) => {
    commit('setIsMobile', isMobile);
};

export const changeLoading = ({ commit }, loading) => {
    commit('setLoading', loading);
};

export const addError = ({ commit }, e) => {
    commit('updateAddError', e);
};

export const resetAllErrors = ({ commit }) => {
    commit('resetErrors');
};